var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.205,
    height: 15.399,
    viewBox: "0 0 8.205 15.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(0 -1.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 1.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "down",
    d: "M0,0V8.2L6.447,4.1Z",
    transform: "translate(8.205 8.953) rotate(90)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "up",
    d: "M0,0V8.2L6.447,4.1Z",
    transform: "translate(0 6.447) rotate(-90)",
    fill: "#18d181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a8b03ead5d57d08a29fa8b69532ee862.svg";
export { ForwardRef as ReactComponent };